import { checkauth } from '../Helper';

const Aruba = () => import('../views/aruba/Index.vue');
// Crea fattura dell'ordine: pagina, non finestra
const ArubaFattura = () => import('../views/aruba/Fattura.vue');

function auth(to, from, next) {
	checkauth().then(response => (response ? next() : next('/login')));
}

export default [
	{
		path: '/aruba',
		name: 'aruba',
		component: Aruba,
		beforeEnter: auth,
	},
	{
		path: '/aruba/:id([0-9a-fA-F]{24})/fattura',
		name: 'aruba-fattura',
		component: ArubaFattura,
		beforeEnter: auth,
	},
];
